import { TranslationGroup } from 'mm-web-core/i18n/tanslation-group';
import { mmLanguageConstants } from './language-constants';
import { en, zh } from './i18n';

export const mmLanguageTranslationGroup = {
    groupName: mmLanguageConstants.translationGroup,
    translations: {
        "en": en,
        "zh": zh
    }
} as TranslationGroup
